import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import replayButton from '../assets/images/replay.svg';
import playButton from '../assets/images/play.svg';
import bars2 from '../assets/images/bars2-and-notes.svg';
import pauseButton from '../assets/images/pause-button.svg';
import ReactGA from 'react-ga';


export default class Fact extends Component {

    constructor() {
        super();

        this.state = {
            isPlaying: false,
            percentComplete: 0
        };

        this.playFullSong = this.playFullSong.bind(this);
        this.pauseFullSong = this.pauseFullSong.bind(this);
        this.replayFullSong = this.replayFullSong.bind(this);
        this.updatePlayhead = this.updatePlayhead.bind(this);
    }

    getNextRoute() {
        switch (this.props.factIndex) {
            case 0: return "/quiz/instructions";
            case 1: return "/puzzle/instructions";
            case 2: return "/tap/instructions";
        }
    }

    playFullSong() {
        document.getElementById("full-song").play();
        this.setState({
            isPlaying: true
        });
        ReactGA.event({
            category: "fact",
            action: "play/pause",
            label: "song player",
            value: this.props.songId,
        });
        if (this.props.isReplay){
            ReactGA.event({
                category: "fact repeat",
                action: "play/pause",
                label: "song player",
                value: this.props.songId,
            });
        }
        // ga("send","event","fact","play/pause", "song player", this.props.songId)
    }

    pauseFullSong() {
        document.getElementById("full-song").pause();
        this.setState({
            isPlaying: false
        });
        ReactGA.event({
            category: "fact",
            action: "play/pause",
            label: "song player",
            value: this.props.songId,
        });
        if (this.props.isReplay){
            ReactGA.event({
                category: "fact repeat",
                action: "play/pause",
                label: "song player",
                value: this.props.songId,
            });
        }
        // ga("send","event","fact","play/pause", "song player", this.props.songId)
    }

    replayFullSong() {
        const audioPlayer = document.getElementById("full-song");
        audioPlayer.currentTime = 0;
        audioPlayer.pause();
        this.setState({
            isPlaying: false
        });
        ReactGA.event({
            category: "fact",
            action: "replay",
            label: "song player",
            value: this.props.songId,
        });
        if (this.props.isReplay){
            ReactGA.event({
                category: "fact repeat",
                action: "replay",
                label: "song player",
                value: this.props.songId,
            });
        }
        // ga("send","event","fact","replay", "song player", this.props.songId)
    }

    updatePlayhead(event) {
        const currentTime = event.target.currentTime;
        const duration = event.target.duration;
        const percentComplete = currentTime / duration;
        this.setState({
            percentComplete: percentComplete
        });
    }

    render() {
        return (
            <section className="fact-page-container">
                <header className="page-header">
                    <img className="header-image"
                         src={bars2}
                         alt="Music Staff and Notes illustration"
                    />
                    <h1 className="page-title">Did you know?</h1>
                </header>
                {
                    this.props.factIndex === 0 &&
                    <section className="audio-player-container">
                    <label>Listen to <i> {this.props.songTitle} </i> </label>
                        <div className="audio-player">
                            <audio id="full-song"
                                   src={this.props.fullSong}
                                   onTimeUpdate={this.updatePlayhead}
                            />
                            <div className="audio-player_line">
                                <div className="audio-player_scrubber"
                                     style={{left: this.state.percentComplete * 100 + "%"}}
                                />
                            </div>
                            <div className="buttons-container">
                                <button altText="replay song"
                                        onClick={this.replayFullSong}
                                >
                                    <img src={replayButton}
                                         alt="Click to restart song"
                                    />
                                </button>
                                <button altText={(this.state.isPlaying ? "pause" : "play")+" song"}
                                        onClick={() => {
                                            if(this.state.isPlaying){
                                                this.pauseFullSong();
                                            } else {
                                                this.playFullSong();
                                            }
                                        }}
                                >
                                    <img src={this.state.isPlaying ? pauseButton : playButton}
                                         alt={"Click to "+(this.state.isPlaying ? "pause" : "play")+" song"}
                                    />
                                </button>
                            </div>
                        </div>
                    </section>
                }
                <article className="main-content">
                    <p dangerouslySetInnerHTML={{__html: this.props.fact.text}}></p>
                    <div className="image-container">
                        <img src={this.props.fact.imageURL}
                             alt={this.props.fact.altText}
                        />
                        {/* TODO add correct caption info for every photo */}
                        <small>{this.props.fact.copyright}</small>
                    </div>
                </article>

                <footer className="page-footer">

                    <Link className="button-primary button-exit" to="/songs">Exit </Link>

                    <Link className="button-primary" to={this.getNextRoute()}
                          onClick={() => {
                              this.props.incrementFactCounter();
                          }}
                    >Next</Link>
                </footer>
            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Fact.js